


























import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import { SNACKBAR_DURATION_MILLISECONDS } from "@/services/constants";
import { JinroGamePlayinfoDocument } from "../../services/datatypes";

@Component({})
export default class LeftTimer extends Vue {
  leftSecondForDisplay: number | null = null;
  timerId: number | null = null;

  get jinroPlayinfoId(): string {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame.currentJinroPlayinfoId;
    }
    return "";
  }

  get endedAt(): firebase.firestore.Timestamp | null {
    if (
      !this.$store.state.jinroGamePlayinfo ||
      !this.$store.state.jinroGamePlayinfo.endedAt
    ) {
      return null;
    }
    const endedAt = this.$store.state.jinroGamePlayinfo.endedAt;

    return endedAt;
  }

  @Watch("jinroPlayinfoId")
  onJinroPlayinfoIdChange() {
    this.destroyTimer();
  }

  @Watch("endedAt")
  onEndedTimChange() {
    this.destroyTimer();
    this.startTimer();
  }

  @Watch("gmTimerStoppedAt", { deep: true })
  onGmTimerStoppedAtChange(val: firebase.firestore.Timestamp | undefined) {
    if (!val) {
      return;
    }
    this.destroyTimer();
  }

  startTimer() {
    this.leftSecondForDisplay = this.leftSeconds;
    const findTimeLeft = () => {
      if (this.leftSecondForDisplay) {
        this.processSnackBar(this.leftSecondForDisplay);
        if (!this.isTimerStopped) {
          this.leftSecondForDisplay = this.leftSecondForDisplay - 1;
        }
      }
    };
    findTimeLeft();
    this.timerId = setInterval(findTimeLeft, 1000);
  }

  created() {
    this.startTimer();
  }

  beforeDestroy() {
    this.destroyTimer();
  }
  destroyTimer(): void {
    this.timerId && clearInterval(this.timerId);
  }

  get gmTimerStoppedAt(): firebase.firestore.Timestamp | null {
    if (!this.$store.state.jinroGamePlayinfo) {
      return null;
    }
    const jinroGamePlayinfo = this.$store.state
      .jinroGamePlayinfo as JinroGamePlayinfoDocument;

    return jinroGamePlayinfo.gmTimerStoppedAt as firebase.firestore.Timestamp;
  }

  get isTimerStopped(): boolean {
    if (!this.gmTimerStoppedAt) {
      return false;
    }

    return !!this.gmTimerStoppedAt;
  }

  get leftTimerStoppedAt(): string {
    if (
      !this.$store.state.jinroGamePlayinfo ||
      !this.$store.state.jinroGamePlayinfo.leftSecondsWhenTimerStopped
    ) {
      return "";
    }
    const leftTimerStoppedAt = this.$store.state.jinroGamePlayinfo
      .leftSecondsWhenTimerStopped as number;

    return this.getTimerString(leftTimerStoppedAt);
  }

  getTimerString(ls: number): string {
    const min = Math.floor(ls / 60);
    const sec = ls % 60;

    if (min > 0) {
      return `${min} 分${sec} 秒`;
    } else {
      return `     ${sec} 秒`;
    }
  }

  get leftTimer(): string {
    if (this.leftSecondForDisplay === null || this.leftSecondForDisplay <= 0) {
      this.timerId && clearInterval(this.timerId);
      return "";
    }

    return this.getTimerString(this.leftSecondForDisplay);
  }

  get leftSeconds(): number {
    if (!this.$store.state.jinroGamePlayinfo) {
      return 0;
    }
    const now = Math.floor(new Date().getTime() / 1000);
    let leftSeconds = 0;

    if (this.endedAt) {
      leftSeconds = this.endedAt.seconds - now;
    } else {
      const startedAt = this.$store.state.jinroGamePlayinfo
        .startedAt as firebase.firestore.Timestamp;
      const playTimelimitSeconds = this.$store.state.jinroGamePlayinfo
        .playTimelimitSeconds as number;
      if (!startedAt || !playTimelimitSeconds) {
        return 0;
      }
      leftSeconds = startedAt.seconds + playTimelimitSeconds - now;
    }

    return leftSeconds;
  }

  processSnackBar(leftSeconds: number): void {
    const min = Math.floor(leftSeconds / 60);
    const sec = leftSeconds % 60;
    // 0だとワンテンポ遅れる
    if (sec === 1 && min !== 0) {
      Snackbar.open({
        duration: SNACKBAR_DURATION_MILLISECONDS,
        queue: false,
        actionText: null,
        message: `残り${min}分`
      });
    }

    // 30, 10だとワンテンポ遅れる
    if ((sec === 31 && min === 0) || (sec === 11 && min === 0)) {
      Snackbar.open({
        duration: SNACKBAR_DURATION_MILLISECONDS,
        queue: false,
        actionText: null,
        message: `残り${sec - 1}秒`
      });
    }

    if (sec === 1 && min === 0) {
      Snackbar.open({
        duration: SNACKBAR_DURATION_MILLISECONDS,
        queue: false,
        actionText: null,
        message: "終了"
      });
    }
  }
}
